<!-- 合同协议 -->
<template>
  <div class='protol flex flex-column justify-content-center align-items-center'>
    <h3>{{title}}</h3>
    <div class="content" v-html="protol"></div>
    <input type="button" value="同意" class="lg-btn" @click="agree">
  </div>
</template>

<script>
import { reqProtol } from "@/api";

export default {
  name: 'Protol',

  components: {},

  data () {
    return {
      title: "",
      protol: "",
    };
  },

  computed: {},

  created() {
    this.getProtol()
  },

  methods: {
    getProtol() {
      reqProtol({ copyType: this.$route.query.type }).then(res => {
        this.protol = res[0].copyContent
        this.title = res[0].copySubject
      })
    },
    agree() {
      localStorage.setItem('agreeProtol', 1)
      this.$router.go(-1)
    },
  },
}

</script>

<style lang='less' scoped>
  .protol {
    padding: 20px 20px 30px;
    h3 {
      font-size: 17px;
    }
  }
  .content {
    padding: 10px 0 17px;
    box-sizing: border-box;
    min-height: 80vh;
  }
</style>